import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-bootstrap/lib/Modal';
import TicketInfoHeader from './TicketInfoHeader';
import TicketInfoValidation from './TicketInfoValidation';
import { connect } from 'react-redux';
import TicketInfoLogs from './TicketInfoLogs';
import {FormattedMessage} from "react-intl";
import moment from "moment-timezone";

class TicketInfo extends Component {
  render() {
    const { ticketInfo, validation } = this.props;
    const timeZone = JSON.parse(sessionStorage.getItem("timeZone"));
      return (
      <div>
        <Modal.Header closeButton>
          <Modal.Title className="title">
	          <FormattedMessage defaultMessage="Detalles de tu última validación" id="title.modal.details.last.validation"/><span className="pull-right time">
              {validation && (
                  moment(validation[0].scanDate).tz(timeZone).format("HH:mm:ss")
              )}
            </span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
	          <TicketInfoHeader ticketInfo={ticketInfo} />

          {validation && <TicketInfoValidation validation={validation} />}

		        <TicketInfoLogs ticketInfo={ticketInfo} />

        </Modal.Body>
      </div>
    );
  }
}

TicketInfo.PropTypes = {
  validation: PropTypes.array,
  ticketInfo: PropTypes.object
};

export default connect()(TicketInfo);
